import { render } from "./Kasir_v.vue?vue&type=template&id=02f0afba&scoped=true"
import script from "./Kasir_v.vue?vue&type=script&lang=js"
export * from "./Kasir_v.vue?vue&type=script&lang=js"

import "./Kasir_v.vue?vue&type=style&index=0&id=02f0afba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02f0afba"

export default script